import { VueConstructor } from 'vue'
import moment from 'moment'
import vueMoment from 'vue-moment'

require('moment/locale/pt-br')

export function installVue2Moment(Vue: VueConstructor) {
    moment.locale('pt-br')
    Vue.use(vueMoment)
}
